import _ from 'lodash';

/**
 * Component resize mixin
 *
 * @usage
 *
 * In the target component:
 *
 *  - Add to mixins array: mixins: [ resizable ]
 *  - Add callback: onResize(width, height) { ... }
 */
export default {
  created() {
    this.__onResize = _.debounce(() => {
      this.onResize(window.innerWidth, window.innerHeight)
    }, 150);
    window.addEventListener('resize', this.__onResize);
  },

  destroyed() {
    window.removeEventListener('resize', this.__onResize);
  },

  methods: {
    onResize: function () {
      console.warn('onResize callback must be overridden in component', this.$vnode);
    }
  }
}
